/* ============================================================
   miori · Kochmesser-Landingpage
   1. Messer-Finder: 3-Fragen State-Machine → 9 Empfehlungen
   2. Anchor-Nav: Scroll-Spy (active class)
   ============================================================ */
(function () {
  "use strict";

  /* ── 1. FINDER ─────────────────────────────────────── */
  function initFinder(root) {
    if (!root || root.dataset.mmInit === "1") return;
    root.dataset.mmInit = "1";

    const state = { wen: null, budget: null, stil: null };

    // Build lookup: "stil__budget" → rec element
    const lookup = {};
    root.querySelectorAll("[data-mm-rec]").forEach(function (el) {
      const key = el.dataset.stil + "__" + el.dataset.budget;
      lookup[key] = el;
    });

    const resultEl  = root.querySelector("[data-mm-result]");
    const badgeEl   = root.querySelector("[data-mm-badge]");
    const titleEl   = root.querySelector("[data-mm-title]");
    const textEl    = root.querySelector("[data-mm-text]");
    const ctaAnchor = root.querySelector("[data-mm-cta-anchor]");
    const ctaSecond = root.querySelector("[data-mm-cta-second]");

    function render() {
      if (!state.budget || !state.stil) return;
      const key = state.stil + "__" + state.budget;
      const rec = lookup[key];
      if (!rec) return;

      const isGeschenk = state.wen === "geschenk";
      badgeEl.textContent   = rec.dataset.badge;
      titleEl.textContent   = rec.dataset.title;
      textEl.textContent    = isGeschenk ? rec.dataset.textGeschenk : rec.dataset.textIch;
      ctaAnchor.href        = rec.dataset.anchor;
      ctaAnchor.textContent = "Zur Marke";
      ctaSecond.textContent = isGeschenk ? rec.dataset.ctaGeschenk : rec.dataset.ctaIch;
      if (isGeschenk && rec.dataset.ctaGeschenk.includes("0681")) {
        ctaSecond.href = "tel:+496819880890";
      } else {
        ctaSecond.href = "#besuchen";
      }

      resultEl.hidden = false;
      resultEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }

    root.querySelectorAll("[data-mm-group]").forEach(function (group) {
      const groupName = group.dataset.mmGroup;
      group.addEventListener("click", function (e) {
        const pill = e.target.closest(".miori-m-pill");
        if (!pill) return;
        group.querySelectorAll(".miori-m-pill").forEach(function (p) { p.classList.remove("on"); });
        pill.classList.add("on");
        state[groupName] = pill.dataset.mmVal;
        render();
      });
    });
  }

  /* ── 2. ANCHOR-NAV SCROLL-SPY ──────────────────────── */
  function initAnchorNav() {
    const nav = document.querySelector(".miori-m-anchornav");
    if (!nav) return;
    const links = Array.from(nav.querySelectorAll(".miori-m-anchornav__link"));
    const targets = links.map(function (l) {
      const id = l.getAttribute("href").replace("#", "");
      return document.getElementById(id);
    }).filter(Boolean);

    if (!targets.length) return;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        const id = entry.target.id;
        links.forEach(function (l) {
          l.classList.toggle("active", l.getAttribute("href") === "#" + id);
        });
      });
    }, { rootMargin: "-40% 0px -55% 0px" });

    targets.forEach(function (t) { observer.observe(t); });
  }

  /* ── BOOT ───────────────────────────────────────────── */
  function boot() {
    document.querySelectorAll(".miori-m-finder").forEach(initFinder);
    initAnchorNav();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
